import { render, staticRenderFns } from "./DeleteDashboard.vue?vue&type=template&id=0adf8cf6"
import script from "./DeleteDashboard.vue?vue&type=script&lang=js"
export * from "./DeleteDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports